import { render, staticRenderFns } from "./DashboardIndex.vue?vue&type=template&id=7a50526c&scoped=true&"
import script from "./DashboardIndex.vue?vue&type=script&lang=js&"
export * from "./DashboardIndex.vue?vue&type=script&lang=js&"
import style0 from "./DashboardIndex.vue?vue&type=style&index=0&id=7a50526c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a50526c",
  null
  
)

export default component.exports